import { render, staticRenderFns } from "./MagazineRecipientList.vue?vue&type=template&id=79f66451&"
import script from "./MagazineRecipientList.vue?vue&type=script&lang=js&"
export * from "./MagazineRecipientList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports